<div class="container h-100 canvas-page">
  <div *ngIf="isLoading" class="row h-100 justify-content-center align-items-center">
    <div class="text-center">
      <app-loading-spinner></app-loading-spinner>
    </div>
  </div>
  <div class="row justify-content-center align-items-center VerticalMargin mb-5" *ngIf="!isLoading">
    <div class="card RegularForm rounded col-12 col-lg-10 canvas-panel">
      <div class="card-body MyCardBody rounded-bottom" [class.SmallArabicFont]="globalService.isRTL == true"
        *ngIf="isLoading == false">

        <form *ngIf="isQR == false && isDetails == false">
          <div class="col-12" *ngIf="userId == null">
            <div>{{ 'PLEASE_ENTER_YOUR_CELL_PHONE_NUMBER' | translate }}</div>
            <br>
            <app-phone-verify [dial_code]="dial_code" [userExists]="true" [enabled]="true" [portrait]="true"
              [phone_number]=" " (failed)="failedVerification()" (clearEvent)="clearCellPhone()"
              (confirmNumber)="ConfirmCellPhone($event)"></app-phone-verify>
          </div>
          <div *ngIf="userId!=null">
            <div class="row my-3">
              <div class="col-12 text-center" [class.text-right]="globalService.isRTL == true">
                <span class="namestyle text-center">{{ name }}</span>
              </div>
            </div>
            <div class="row">
              <div class="col-8" [class.text-right]="globalService.isRTL == true">
                <label for="point_system" class="text-secondary"
                  [class.SmallArabicFont]="globalService.isRTL == true">{{
                  globalService.Get("POINT_SYSTEM") }}</label>
                <select id="point_system" class="form-control" [class.classicRTL]="globalService.isRTL == true"
                  (change)="updateActivities()" [class.classic]="globalService.isRTL == false"
                  [(ngModel)]="currentPointSystem" [ngModelOptions]="{standalone: true}">
                  <option *ngFor="let point_system of data.pointSystems" [value]="point_system.id">
                    {{ point_system.name }}
                  </option>
                </select>
              </div>
              <div class="col-4" [class.text-right]="globalService.isRTL == true">
                <label for="total" class="text-secondary" [class.SmallArabicFont]="globalService.isRTL == true">{{
                  globalService.Get("TOTAL") }}</label>
                <input class="form-control" readonly [class.classicRTL]="globalService.isRTL == true"
                  [class.classic]="globalService.isRTL == false" [(ngModel)]="totalPoints" [value]="totalPoints"
                  [ngModelOptions]="{standalone: true}" />
              </div>
            </div>
            <div class="row">
              <div class="col-12" [class.text-right]="globalService.isRTL == true">
                <label for="task" class="text-secondary" [class.SmallArabicFont]="globalService.isRTL == true">{{
                  globalService.Get("ACTIVITY") }}</label>
                <select id="task" class="form-control" [class.classicRTL]="globalService.isRTL == true"
                  [class.classic]="globalService.isRTL == false" [(ngModel)]="currentActivity"
                  (change)="updateCurrentPoint()" [ngModelOptions]="{standalone: true}">
                  <option value="0" disabled>{{ 'SELECT' | translate }}</option>
                  <option *ngFor="let activity of activities" [value]="activity.id">
                    {{ activity.task }}
                  </option>
                </select>
              </div>
            </div>
            <div class="row m-5">
              <div class="col-12 m-auto">
                <h4 class="text-center" [ngClass]="currentPoint > 0 ? 'visible' : 'hidden'">{{ currentTask }}</h4>
                <h1 class="text-center" [ngClass]="currentPoint > 0 ? 'visible' : 'hidden'">{{ currentPoint }}</h1>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <app-prompt-message [showForm]="message != ''" [color]="getMessageColor()" (onClose)="message = ''"
                  [message]="message">
                </app-prompt-message>
              </div>
            </div>
            <div class="row">
              <div class="col-5">
                <button class="btn btn-primary btn-block py-3" [disabled]="currentPoint == 0" (click)="addPoint()">
                  <span><i [ngClass]="adding == true ? 'fas fa-spinner fa-spin' : ''"></i>
                    {{ globalService.Get("ADD_POINT") }} </span>
                </button>
              </div>
              <div class="col-7">
                <button class="btn btn-danger btn-block py-3" [disabled]="currentPoint == 0" (click)="deductPoint()">
                  <span><i [ngClass]="deducting == true ? 'fas fa-spinner fa-spin' : ''"></i>
                    {{ globalService.Get("DEDUCT_POINT") }} </span>
                </button>
              </div>
            </div>
            <div class="row my-4">
              <div class="col-5">
                <button class="btn btn-secondary btn-block" (click)="showBarcode()">
                  <span> {{ globalService.Get("BARCODE") }} </span>
                </button>
              </div>
              <div class="col-7">
                <button class="btn btn-secondary btn-block" (click)="showDetails()">
                  <span><i [ngClass]="loadingData == true ? 'fas fa-spinner fa-spin' : ''"></i>
                    {{ globalService.Get("SHOW_DETAILS") }} </span>
                </button>
              </div>
            </div>
          </div>
        </form>
        <form *ngIf="isQR == true && isDetails == false">
          <div class="row my-3">
            <div class="col-12 text-center" [class.text-right]="globalService.isRTL == true">
              <span class="namestyle text-center">{{ name }}</span>
            </div>
            <div class="col-12 mt-4">
              <img *ngIf="qrImage" [src]="qrImage" width="192" />
            </div>
            <div class="col-12 mt-4">
              <button class="btn btn-secondary btn-block" (click)="goHome()">
                <span> {{ globalService.Get("BACK") }} </span>
              </button>
            </div>
          </div>
        </form>
        <form *ngIf="isQR == false && isDetails == true">
          <div class="row my-3">
            <div class="col-12 text-center" [class.text-right]="globalService.isRTL == true">
              <span class="namestyle text-center">{{ name }}</span>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-12 mt-3" [class.SmallArabicFont]="globalService.isRTL == true">
              <input class="form-control filter" type="text" name="search" [(ngModel)]="searchText"
                [placeholder]="globalService.Get('START_TYPING_NAME_OR_TAG')" autocomplete="off" />
            </div>
          </div>
          <div class="row">
            <div class="ProfilePagination text-dark">
              <pagination-controls (pageChange)="p = $event; globalService.page = p"
                [previousLabel]="globalService.Get('PREVIOUS')" [nextLabel]="globalService.Get('NEXT')"
                responsive="true">
              </pagination-controls>
            </div>
          </div>
          <br>
          <div class="row mx-1">
            <table class="table table-striped entity-list-table">
              <thead>
                <tr>
                  <td class="text-center" scope="col-3">{{ 'DATE' | translate }}</td>
                  <td class="text-center" scope="col-3">{{ 'TASK_4BC74B2' | translate }}</td>
                  <td class="text-center" scope="col-2">{{ 'STARS' | translate }}</td>
                  <td class="text-center" scope="col-4">{{ 'SERVANT' | translate }}</td>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let rec of filteredHistory
  | paginate: { itemsPerPage: 5, currentPage: p };
  let indexOfService = index" [ngClass]="rec.Points < 0 ? 'text-danger' : ''">
                  <td class="text-center">{{ rec.Date | localizedDate: 'MM/dd/yy' }}</td>
                  <td class="text-center">{{ rec.Task }}</td>
                  <td class="text-center">{{ rec.Points }}</td>
                  <td class="text-center">{{ rec.Servant }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="ProfilePagination text-dark">
            <pagination-controls (pageChange)="p = $event; globalService.page = p"
              [previousLabel]="globalService.Get('PREVIOUS')" [nextLabel]="globalService.Get('NEXT')" responsive="true">
            </pagination-controls>
          </div>
          <div class="col-12 mt-4">
            <button class="btn btn-secondary btn-block" (click)="goHome()">
              <span> {{ globalService.Get("BACK") }} </span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div> 